import {
  PRODUCT_PROMO_SEGMENT_TYPES_WITH_PROGRAM_BUDGET,
  SELLER_USER_SEGMENT_TYPE,
  TYPE_LIMIT,
} from "features/Campaign/constants";

export const getSellerSegmentIDByType = (segments = [], type) => {
  // BE dùng name làm discriminator, ưu tiên search name trước rồi fallback type
  const segment = segments?.find((item) => item.name === type) || segments?.find((item) => item.type === type);
  return segment?.id;
};

export const getSellerSegmentTypeByID = (segments = [], sellerSegmentID) => {
  if (!sellerSegmentID) {
    return null;
  }
  const segment = segments?.find((item) => item.id === sellerSegmentID);
  if (!segment) return null;
  // BE dùng name làm discriminator, ưu tiên return name nếu khớp FE constant
  const validTypes = Object.values(SELLER_USER_SEGMENT_TYPE);
  if (validTypes.includes(segment.name)) return segment.name;
  return segment?.type || null;
};

export const applyOneTimePurchaseLimitToProductPromoTiers = (promotionCampaignTierGroupsProductPromo = []) => {
  if (!promotionCampaignTierGroupsProductPromo?.length) {
    return promotionCampaignTierGroupsProductPromo;
  }

  return promotionCampaignTierGroupsProductPromo.map((group) => ({
    ...group,
    promotionCampaignTiers: group?.promotionCampaignTiers?.map((tier) => ({
      ...tier,
      limitType: TYPE_LIMIT.LIMIT,
      maxQuantityPerSeller: 1,
    })),
  }));
};

export const applyUnlimitedPurchaseLimitToProductPromoTiers = (promotionCampaignTierGroupsProductPromo = []) => {
  if (!promotionCampaignTierGroupsProductPromo?.length) {
    return promotionCampaignTierGroupsProductPromo;
  }

  return promotionCampaignTierGroupsProductPromo.map((group) => ({
    ...group,
    promotionCampaignTiers: group?.promotionCampaignTiers?.map((tier) => ({
      ...tier,
      limitType: TYPE_LIMIT.NO_LIMIT,
      maxQuantityPerSeller: undefined,
    })),
  }));
};

export const applySellerSegmentToProductPromoTiers = (
  promotionCampaignTierGroupsProductPromo = [],
  sellerSegmentID
) => {
  if (!promotionCampaignTierGroupsProductPromo?.length || !sellerSegmentID) {
    return promotionCampaignTierGroupsProductPromo;
  }

  return promotionCampaignTierGroupsProductPromo.map((group) => ({
    ...group,
    promotionCampaignTiers: group?.promotionCampaignTiers?.map((tier) => ({
      ...tier,
      sellerSegmentID,
    })),
  }));
};

export const mapProductPromoTierBudgetField = (tier, sellerSegmentType) => {
  const { maxBudgetPerSeller, ...rest } = tier || {};
  return PRODUCT_PROMO_SEGMENT_TYPES_WITH_PROGRAM_BUDGET.includes(sellerSegmentType)
    ? { ...rest, maxBudgetPerSeller }
    : { ...rest, budgetAmount: maxBudgetPerSeller };
};

// Đọc đúng field mà mapProductPromoTierBudgetField đã dùng để ghi, theo sellerSegmentType hiện tại.
export const getProductPromoTierBudgetValue = (tier, sellerSegmentType) => {
  return PRODUCT_PROMO_SEGMENT_TYPES_WITH_PROGRAM_BUDGET.includes(sellerSegmentType)
    ? tier?.maxBudgetPerSeller
    : tier?.budgetAmount;
};

export const getProductPromoConfirmBudget = (values) => {
  const requiresProgramBudget = PRODUCT_PROMO_SEGMENT_TYPES_WITH_PROGRAM_BUDGET.includes(values?.sellerSegmentType);

  if (requiresProgramBudget) {
    return values?.maxBudgetPerSeller || 0;
  }

  return (
    values?.promotionCampaignTierGroupsProductPromo?.[0]?.promotionCampaignTiers?.reduce(
      (sum, tier) => sum + (getProductPromoTierBudgetValue(tier, values?.sellerSegmentType) || 0),
      0
    ) || 0
  );
};

export const resolveProductPromoSellerSegmentType = (sellerUserSegmentType) => {
  if (!sellerUserSegmentType || sellerUserSegmentType === SELLER_USER_SEGMENT_TYPE.ALL) {
    return SELLER_USER_SEGMENT_TYPE.ALL;
  }

  if (sellerUserSegmentType === SELLER_USER_SEGMENT_TYPE.NO_ORDER) {
    return SELLER_USER_SEGMENT_TYPE.NO_ORDER;
  }

  return SELLER_USER_SEGMENT_TYPE.NOT_PURCHASED_PRODUCT;
};
